import {Grid, GridSize} from '@material-ui/core';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import React from 'react';
import {useQuoteField} from '../hooks/useHandleQuoteFieldChange';

export type CheckboxInputGridState = {
  _key: {
    id: string;
  };
  name: string;
  _type: string;
  isExclusion: boolean;
};

export type MappingState = {
  label: string;
  path: string;
};

export type CheckboxInputGridProps = {
  state: MappingState[];
  gridLength: boolean | GridSize | undefined;
  hideOnJobAccident?: boolean;
  isMIState?:boolean;
};

export const CheckboxInputGrid = (props: CheckboxInputGridProps) => {

  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {state, gridLength, hideOnJobAccident = true, isMIState} = props;

  return (
    <>
      {Array.isArray(state) && state.length > 0 ? (
        <Grid container>
          {state.map(({label, path}) => {
            // Only hide "On the job accident" in the main exclusions, not in outpatient
            const shouldHide = hideOnJobAccident && label === 'On the job accident';
            const changeLabel = isMIState && label.includes("MD")
              
            return (
              <Grid item key={label} xs={12} sm={6} md={gridLength} style={{padding: '1rem'}}>
                <QuoteFormControlElement
                  controlType="checkbox"
                  id={path}
                  label={!changeLabel ? label : "Willful criminal activity (MI Only)"}
                  checked={getQuoteFieldValue<boolean>(path)}
                  onChange={e => updateQuoteFieldValue(path, e.target.checked)}
                  disabled
                  hidden={shouldHide}
                />
              </Grid>
            );
          })}
        </Grid>
      ) : null}
    </>
  );
};